import $http from "../../axios";
import * as mutations from './mutations'
import {Notification} from "element-ui";

export async function downloadClientsTemplate({state},download_info) {
    let name = 'clientes.xlsx'
    state.loading.module = true;

    await $http({
        url: '/api/descargar-plantilla-clientes?download_data='+download_info,
        method: 'GET',
        responseType: 'blob',
    }).then((response) => {
           state.loading.module = false;
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', name);
            document.body.appendChild(link);
            link.click();

    }).catch((error) => {
        state.loading.module = false;
        Notification.error({
            title: 'Error!',
            message: error.message,
            type: 'error',
            duration: 3000,
            customClass: 'notification-box',
        });
    })
}
export async function uploadClientsTemplate({state}) {
    let formData = new FormData();
    formData.append('file', state.file);
    state.loading.module = true ;
    $http.post(`/api/cargar-plantilla-clientes`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }
    ).then(function(){
        state.loading.module = false ;
        state.file = '' ;
        Notification.success({
            title: "Success!",
            message: 'Archivo cargado',
            type: "success",
            duration: 3000,
            customClass: "notification-box"
        });
    })
        .catch(error => {
            state.loading.module = false ;
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 3000,
                customClass: "notification-box"
            });
        });
}



// WEBPACK FOOTER //
// ./src/modules/import-terceros/actions.js